// 收入预测模块-埋点配置
const config = {
    'revenuePending': {
        'bigData-tab-revenue-pending-industry': '待办管理,收入预测待办完成情况,行业,',
        'bigData-tab-revenue-pending-company': '待办管理,收入预测待办完成情况,分公司,',
        'bigData-tab-revenue-pending-personal': '待办管理,收入预测待办完成情况,个人,'
    },
    'commissionFlow': {
        'bigData-btn-commission-flow-save': '待办管理,收入预测待办,基础信息,保存',
        'bigData-btn-commission-flow-submit': '待办管理,收入预测待办,基础信息,提交',
        'bigData-btn-commission-flow-approve': '待办管理,收入预测待办,流程信息,提交审批',
        'bigData-btn-commission-flow-upload': '待办管理,收入预测待办,基础信息,上传附件',
        'bigData-btn-commission-flow-preview': '待办管理,收入预测待办,基础信息,预览附件',
        'bigData-btn-commission-flow-download': '待办管理,收入预测待办,基础信息,下载附件',
        'bigData-btn-commission-flow-delete': '待办管理,收入预测待办,基础信息,删除附件'
    }
};

export default config;
